import React, { Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import GifItem from "./GifItem";

const CommentReply = ({
  addPostReply,
  setReplyComment,
  user,
  profile,
  channelid,
  getGifs,
  getGifsSearch,
  gifs,
  replyToComment,
  Reply,
  setPostReply,
}) => {
  const [icon, setIcon] = useState({ text: true, photo: false, video: false });
  const [showGIFs, setshowGIFs] = useState(false);
  const [text, setText] = useState("");
  const [gifSearch, setGifSearch] = useState(false);

  const maxLength = 100;

  useEffect(() => {
    getGifs();
  }, [getGifs]);

  return (
    <Fragment>
      <div className="create-post-overlay">
        <form
          className="create-post-box"
          onSubmit={(e) => {
            e.preventDefault();
            if (Reply.text !== "" || Reply.gif !== "") {
              addPostReply(
                replyToComment.id,
                replyToComment.commentId,
                channelid,
                Reply.text,
                Reply.gif
              );
              setPostReply({ text: "", gif: "" });
              setReplyComment(false);
            }
          }}
        >
          <div className="flex-only-center-alt">
            <div className="">
              <div className="flex-only-container">
                <div className="comment-avi-container">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${replyToComment.avatar}`}
                    alt="avatar"
                    className="comment-avi"
                  />
                </div>
                <ul className="post-user-items">
                  <div className="align-center">
                    <li
                      className={`item-font ${
                        replyToComment.role &&
                        replyToComment.role === "innovator"
                          ? "green"
                          : replyToComment.role &&
                            replyToComment.role === "mentor"
                          ? "red"
                          : replyToComment.role &&
                            replyToComment.role === "employer"
                          ? "blue"
                          : ""
                      } bold`}
                    >
                      {replyToComment.channelid}{" "}
                    </li>
                    {profile.channelid === replyToComment.channelid ? (
                      <i class="fa-solid fa-crown translate-y mx-5 gold"></i>
                    ) : (
                      ""
                    )}
                  </div>
                  <li className="stream-item bold">
                    {replyToComment.firstname}{" "}
                    {replyToComment.channelid === "roland"
                      ? ""
                      : replyToComment.lastname}
                  </li>
                  <li className="stream-item">{replyToComment.jobtitle}</li>
                </ul>
              </div>
              {replyToComment.gif && replyToComment.gif !== "" && (
                <img
                  src={replyToComment.gif}
                  alt="media"
                  className="reported-media-alt"
                />
              )}
              {replyToComment.text !== "" && (
                <div className="user-request-text white">
                  {replyToComment.text}
                </div>
              )}
            </div>
          </div>
          <div className="create-post-avi-text">
            <div className="create-post-avi-container">
              <img
                className="create-post-avi"
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                  user && user.avatar
                }`}
                alt="avatar"
              />
            </div>
            <div className="create-post-text-container">
              <div>
                {icon.text && (
                  <div className="relative-textarea-container">
                    <textarea
                      className="create-post-text-alt"
                      name="text"
                      maxLength={100}
                      value={Reply.text}
                      onChange={(e) => {
                        setPostReply({ ...Reply, text: e.target.value });
                      }}
                      placeholder="Reply to comment above"
                    ></textarea>
                    <p className="white character-counter-alt">
                      {Reply.text.split("").length}/{maxLength} characters
                    </p>
                  </div>
                )}
                {showGIFs && Reply.gif === "" && icon.gif && (
                  <div className="comment-gif-input-hidden-post">
                    <div className="giphy-container-post">
                      <div className="wrap-container-alt">
                        <div
                          className={`powered-by-giphy-alt ${
                            user && user.role === "innovator"
                              ? "green"
                              : user && user.role === "mentor"
                              ? "red"
                              : user && user.role === "employer"
                              ? "blue"
                              : ""
                          }`}
                        >
                          Powered By
                        </div>
                        <img
                          src={
                            "https://ime.sfo3.cdn.digitaloceanspaces.com/img/Giphy_Logo.png"
                          }
                          style={{
                            width: "80px",
                            margin: "0px 10px",
                          }}
                          alt="logo"
                        />
                      </div>
                      <div
                        className="gifs-alt"
                        id={`${
                          user && user.role === "innovator"
                            ? "green-scroll"
                            : user && user.role === "mentor"
                            ? "red-scroll"
                            : user && user.role === "employer"
                            ? "blue-scroll"
                            : ""
                        }`}
                      >
                        {!gifSearch &&
                          gifs.map((gif) => (
                            <div
                              className="gif-choice"
                              onClick={(e) => {
                                setPostReply({
                                  ...Reply,
                                  gif: e.target.attributes["src"].value,
                                });
                              }}
                            >
                              <GifItem key={gif.id} gif={gif} />
                            </div>
                          ))}
                        {gifSearch &&
                          gifs.map((gif) => (
                            <div
                              className="gif-choice"
                              onClick={(e) => {
                                setPostReply({
                                  ...Reply,
                                  gif: e.target.attributes["src"].value,
                                });
                              }}
                            >
                              <GifItem key={gif.id} gif={gif} />
                            </div>
                          ))}
                      </div>
                      <form
                        className="gif-input-hidden"
                        onSubmit={(e) => {
                          e.preventDefault();
                          getGifsSearch({ text });
                          setText("");
                          setGifSearch(true);
                        }}
                      >
                        <input
                          type="text"
                          className="gif-input"
                          name="text"
                          value={text}
                          onChange={(e) => setText(e.target.value)}
                          placeholder="Search for GIFs..."
                        />
                        <button
                          type="submit"
                          onSubmit={(e) => {
                            e.preventDefault();
                            getGifsSearch({ text });
                            setText("");
                            setGifSearch(true);
                            setshowGIFs(false);
                          }}
                          className={`gif-input-button ${
                            user && user.role === "innovator"
                              ? "background-green"
                              : user && user.role === "mentor"
                              ? "background-red"
                              : user && user.role === "employer"
                              ? "background-blue"
                              : ""
                          }`}
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </form>
                    </div>
                  </div>
                )}
                {Reply.gif !== "" && icon.gif && (
                  <div className="flex-only-container">
                    <img
                      src={Reply.gif}
                      alt="upload-file-avatar"
                      className="upload-file"
                    />
                    <i
                      className="far fa-times fa-lg selected-gif-x-alt"
                      onClick={() => {
                        setPostReply({ ...Reply, gif: "" });
                      }}
                    ></i>
                  </div>
                )}
              </div>
            </div>
            <div>
              <i
                className="fas fa-times fa-3x clear"
                onClick={() => setReplyComment(false)}
              ></i>
            </div>
          </div>
          <div className="post-type-container">
            <p
              onClick={() => setIcon({ text: true, gif: false })}
              className={`icon-wrap ${
                icon.text ? "background-black-light" : ""
              }`}
            >
              <i
                class={`fa-solid fa-pencil fa-2x ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              ></i>
            </p>
            {user.founding_supporter_type !== "" &&
              user.founding_supporter_type !== "Good" && (
                <p
                  onClick={() => {
                    setshowGIFs(true);
                    setIcon({
                      text: false,
                      gif: true,
                    });
                  }}
                  className={`icon-wrap ${
                    icon.gif && user && user.role === "innovator"
                      ? "background-black-light green"
                      : icon.gif && user && user.role === "mentor"
                      ? "background-black-light red"
                      : icon.gif && user && user.role === "employer"
                      ? "background-black-light blue"
                      : !icon.gif && user && user.role === "innovator"
                      ? "green"
                      : !icon.gif && user && user.role === "mentor"
                      ? "red"
                      : !icon.gif && user && user.role === "employer"
                      ? "blue"
                      : ""
                  }`}
                >
                  <i
                    class={`fa-solid fa-photo-film fa-2x mr-5 ${
                      user && user.role === "innovator"
                        ? "green"
                        : user && user.role === "mentor"
                        ? "red"
                        : user && user.role === "employer"
                        ? "blue"
                        : ""
                    }`}
                  ></i>
                  GIF
                </p>
              )}
          </div>
          <div className="create-post-button-container">
            <button
              className={`create-post-button-alt ${
                user && user.role === "innovator"
                  ? "background-green"
                  : user && user.role === "mentor"
                  ? "background-red"
                  : "background-blue"
              }`}
            >
              <i className="far fa-edit mx-5"></i>Add Reply to Comment
            </button>
          </div>
        </form>
      </div>
    </Fragment>
  );
};

CommentReply.propTypes = {
  auth: PropTypes.object.isRequired,
  addPostReply: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(CommentReply);
